export {
  between,
  callIfDefined,
  min,
  max,
  updateInputWidth,
} from 'react-date-picker/dist/shared/utils';

export {
  getAmPmLabels,
} from 'react-time-picker/dist/shared/utils';



// WEBPACK FOOTER //
// ./src/app/components/react-datetime-picker/shared/utils.js